import { useState } from 'react'
import { Modal, ModalBody } from 'components/modal'
import { RadioGroup, Radio, Form } from 'components/forms'
import { InfoButton } from 'components/buttons'
import { Col, Row } from 'react-bootstrap'
import { SubHeading } from 'components/headings'
import { useForm } from 'react-hook-form'
import css from './tell-us-why-modal.scss'

const TellUsWhyModal = ({ Header, subHeadingText, onSubmit }) => {
  const { register, handleSubmit, errors } = useForm()

  const reasons = [
    'Baby Arrived',
    'Experienced a Loss',
    'Too Much Email',
    'Just Because',
  ]

  const handleReasonSubmit = (data) => {
    const reason = data.reason
    onSubmit && reason && onSubmit(reason)
  }

  return (
    <Modal show closeButton={false}>
      <ModalBody>
        {Header}
        <Row>
          <Col xs={12}>
            <SubHeading className="h5 text-bold ptl full-width text-center">
              {subHeadingText}
            </SubHeading>
            <Form
              onSubmit={handleSubmit(handleReasonSubmit)}
              className="flex col align-center"
            >
              <RadioGroup className="mbn">
                {reasons.map((reason) => (
                  <Radio
                    key={reason}
                    label={reason}
                    name="reason"
                    inputRef={register({
                      required: 'Selection is required',
                    })}
                    value={reason}
                  />
                ))}
              </RadioGroup>
              {errors && (
                <p className={css.errorMessage}>{errors.reason?.message}</p>
              )}
              <InfoButton className="mbm" type="submit" pill>
                Submit
              </InfoButton>
            </Form>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  )
}

export default TellUsWhyModal
